import axios from "axios";
import { useAuthStore } from "./newSrc/stores/authStore.js";

var origin = window.location.origin;

var url = import.meta.env?.VITE_IS_SSL
	? `https://${location.hostname}`
	: `${origin}`;

var apiUrl = `${url}/admin/api`;

const base_url =
	import.meta.env?.MODE === "development" ? apiUrl : `${url}/admin/api`;

const api = axios.create({
	baseURL: base_url,
	headers: {
		"Content-Type": "application/json",
	},
});

let isRefreshing = false;

const refreshAndRetryQueue = [];

api.interceptors.request.use(async (config) => {
	config.params = config.params || {};
	const state = JSON.parse(localStorage.getItem("authState"));
	const userType = state?.user?.userType;
	config.params["user_type"] = userType;
	if (location.href.includes("newjournal")) {
		if (state?.isAuthenticated && userType === "student") {
			config.params["user_id"] = state.user.id;
			config.headers.Authorization = state.token
				? `Bearer ${state.token}`
				: null;
		}
	} else if (typeof client_db_name !== "undefined") {
		config.params["db_name"] = client_db_name;
		config.params["user_id"] = current_user_id;
		config.params["user_token"] = current_user_token;
		config.params["user_type"] = "user";
	} else if (!state?.isAuthenticated && userType === "student") {
		config.params["user_id"] = state.user.id;
	}
	return config;
});

api.interceptors.response.use(
	(response) => response,
	async (error) => {
		console.log(error);
		if (
			JSON.parse(localStorage.getItem("authState"))?.user?.userType ===
			"student"
		) {
			const originalRequest = error.config;

			if (error.response && error.response.status === 401) {
				if (!isRefreshing && !originalRequest._retry) {
					const authStore = useAuthStore();
					isRefreshing = true;

					try {
						console.log("Refreshing token...");
						const {
							data: { token: newAccessToken },
						} = await authStore.refresh();

						if (newAccessToken) {
							originalRequest._retry = true;

							originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

							refreshAndRetryQueue.forEach(
								({ config, resolve, reject }) => {
									axios
										.request(config)
										.then((response) => resolve(response))
										.catch((err) => reject(err));
								},
							);

							refreshAndRetryQueue.length = 0;

							return axios(originalRequest);
						}
					} catch (err) {
						console.error("Error refreshing token:", err);
						authStore.logout();
					} finally {
						isRefreshing = false;
					}
				}

				// Add the original request to the queue
				return new Promise((resolve, reject) => {
					refreshAndRetryQueue.push({
						config: originalRequest,
						resolve,
						reject,
					});
				});
			}

			return Promise.reject(error);
		}
	},
);

export default api;
